export default __webpack_public_path__ + "media/images/brands/xpress/logos/email_logo-fc38b62baebb0ffb0225256a9222d2c0.png";